import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SubmitButton from 'shared/components/SubmitButton';
import { Investment_IdeaType } from 'types/common';
import { useIdeaOrderArchive } from './hooks';

interface Props {
  orderId: number;
  ideaType: Investment_IdeaType;
}

export const ArchiveIdeaButton: React.FC<Props> = ({ orderId, ideaType }) => {
  const { t } = useTranslation();
  const { archive, loading, error } = useIdeaOrderArchive(orderId, ideaType);

  return (
    <SubmitButton onClick={archive} primary error={error} submitting={loading}>
      {t('Archive')}
    </SubmitButton>
  );
};
